import React from "react";
import { Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useTranslation } from "react-i18next";
import { formLabel } from "../lib/labels.js";

export function ActiveChip({ active }: { active: boolean }) {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      icon={active ? <CheckCircleIcon /> : <CancelIcon />}
      label={active ? t("common.active") : t("common.activeF")}
      color={active ? "success" : "default"}
      variant="outlined"
      sx={{ fontWeight: 600, fontSize: "0.72rem" }}
    />
  );
}

export function SettledChip({ settled }: { settled: boolean }) {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      icon={settled ? <DoneAllIcon /> : <HourglassEmptyIcon />}
      label={settled ? t("common.settled") : t("common.pending")}
      color={settled ? "success" : "warning"}
      variant="outlined"
      sx={{ fontWeight: 600, fontSize: "0.72rem" }}
    />
  );
}

export function QueueStatusChip({ status }: { status: string }) {
  const { t } = useTranslation();
  const colors: Record<string, "default" | "warning" | "success" | "error" | "info"> = {
    pending: "warning", waitingWindow: "info", running: "default", completed: "success", sent: "success", failed: "error", nothingToSettle: "default"
  };
  return (
    <Chip
      size="small"
      label={t(`whatsapp.queueStatus.${status}`, { defaultValue: status })}
      color={colors[status] ?? "default"}
      variant="outlined"
      sx={{ fontWeight: 600, fontSize: "0.72rem" }}
    />
  );
}

export function MessageStatusChip({ status }: { status: string }) {
  const colors: Record<string, "default" | "warning" | "success" | "error" | "info"> = {
    pending: "warning", sent: "info", delivered: "success", read: "success", failed: "error"
  };
  return (
    <Chip
      size="small"
      label={formLabel(`form.whatsapp.${status}`)}
      color={(colors[status] ?? "default") as "default" | "warning" | "success" | "error"}
      variant="outlined"
      sx={{ fontWeight: 600, fontSize: "0.72rem" }}
    />
  );
}

export function PartnerTypeChip({ type }: { type: string }) {
  const colors: Record<string, string> = {
    "form.partnerType.pony": "#7B3F9E",
    "form.partnerType.horse": "#1565C0",
    "form.partnerType.owner": "#2E7D32",
    "form.partnerType.other": "#5D4037"
  };
  const color = colors[type] ?? "#616161";
  return (
    <Chip
      size="small"
      label={formLabel(type)}
      sx={{ fontWeight: 600, fontSize: "0.72rem", bgcolor: color + "18", color, borderColor: color + "40" }}
      variant="outlined"
    />
  );
}
